module.exports = __webpack_public_path__ + "static/media/ic-check-grey.f7e6cccc.svg";